import { Fail } from './fail';

export class ApiFail extends Fail {
  _message = 'Empty error message from server';
}
